import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import { InfoBulle } from '../ImportAll'
import './Bloc.css'

class BlocCheckBox extends Component {
    constructor(props) {
        super(props)
        this.handleCheckBoxUpdate = this.handleCheckBoxUpdate.bind(this)
    }

    handleCheckBoxUpdate(checkBoxTargetValue) {
        if (this.props.linked_data_id) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: this.props.linked_data_id,
                    value: checkBoxTargetValue,
                },
            })
        }
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        let text
        if (this.props.rgpd !== undefined && this.props.rgpd) {
            text = (
                <div className="checkbox-text size14">
                    Je souhaite découvrir immédiatement ma simulation,{' '}
                    <b>gratuitement et sans engagement</b>, recevoir des
                    conseils de mon expert dédié liés aux projets afin
                    d’optimiser mon acquisition immobilière.
                    <br />
                    En cochant cette case, j’accepte les{' '}
                    <a href="/sites/default/files/pdf/cgu.pdf" target="_blank">
                        conditions générales d’utilisation
                    </a>
                    .
                </div>
            )
        }
        if (this.props.rgpd_part !== undefined && this.props.rgpd_part) {
            text = (
                <div className="checkbox-text size14">
                    J’accepte que mes données personnelles relatives à ma
                    capacité maximum d’emprunt et à la faisabilité de mon projet
                    immobilier soient transmises à{' '}
                    <b>{this.props.nomPartenaire}</b> [SIREN :{' '}
                    {this.props.siren}
                    {this.props.orias !== undefined &&
                    this.props.orias !== '' &&
                    this.props.orias !== null
                        ? ' - ORIAS : ' + this.props.orias
                        : ''}
                    ] afin d’être accompagné dans mon projet immobilier.
                    <br />
                    Pour en savoir plus sur la gestion de vos données
                    personnelles et pour exercer vos droits, nous vous invitons
                    à vous reporter à notre{' '}
                    <a
                        href="/sites/default/files/pdf/mec_politique.pdf"
                        target="_blank"
                    >
                        politique de confidentialité (MonEmprunt.com)
                    </a>
                    {this.props.politique && (
                        <>
                            {' '}
                            ou à celle de notre partenaire{' '}
                            <a href={this.props.politique} target="_blank">
                                politique de confidentialité (
                                {this.props.nomPartenaire})
                            </a>
                        </>
                    )}
                    .
                </div>
            )
        }
        if (this.props.demarche_mec !== undefined && this.props.demarche_mec) {
            text = (
                <div className="checkbox-text size14">
                    Acceptez-vous d’être contacté(e) ultérieurement à des fins
                    d’information par MonEmprunt.com sur les nouveaux produits,
                    services et offres commerciales susceptibles de vous
                    intéresser ?
                    <br />
                    Pour en savoir plus sur la gestion de vos données
                    personnelles et pour exercer vos droits, nous vous invitons
                    à vous reporter à notre{' '}
                    <a
                        href="/sites/default/files/pdf/mec_politique.pdf"
                        target="_blank"
                    >
                        politique de confidentialité
                    </a>
                    .
                </div>
            )
        }
        if (
            this.props.demarche_part !== undefined &&
            this.props.demarche_part
        ) {
            text = (
                <div className="checkbox-text size14">
                    Je consens à ce que mes données à caractère personnel soient
                    transmises à nos partenaires. <br />
                    Pour en savoir plus sur la gestion de vos données
                    personnelles et pour exercer vos droits nous vous invitons à
                    vous reporter à notre{' '}
                    <a
                        href="/sites/default/files/pdf/mec_politique.pdf"
                        target="_blank"
                    >
                        politique de confidentialité
                    </a>
                    .
                </div>
            )
        }

        var checkbox
        if (this.props.targetDataValue === true) {
            checkbox = (
                <span
                    className="checkbox"
                    onClick={() => this.handleCheckBoxUpdate(false)}
                >
                    <svg
                        className="checkbox-svg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        color="#58b7b8"
                    >
                        <path
                            color="#58b7b8"
                            d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"
                        />
                    </svg>
                </span>
            )
        } else {
            checkbox = (
                <span
                    className="checkbox"
                    onClick={() => this.handleCheckBoxUpdate(true)}
                ></span>
            )
        }

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    <div className="bloc-checkbox">
                        {checkbox}
                        {text}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
        nomPartenaire: state.answer.tech_part_nom,
        orias: state.answer.tech_part_orias,
        siren: state.answer.tech_part_siren,
        politique: state.answer.tech_part_politique,
        esquiveRgpdPartTunnelPossible: state.esquive_rgpd_part_tunnel_possible,
    }
}

export default connect(mapStateToProps)(BlocCheckBox)
